import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: {
    username: '',
    password: '',
    password2: '',
    email: '',
    name: '',
    surname: '',
    fullName: '',
    companyName: '',
    countryCode: 'TR',
    countryName: 'Türkiye',
    cityCode: '',
    cityName: '',
    districtName: '',
    zipCode: '',
    address: '',
    telephoneAreaCode: '',
    telephone: '',
    mobileAreaCode: '',
    mobile: '',
    taxNumber: '',
    taxOffice: '',
    identityNumber: '',
    roleId: '',
    telephoneCountryCode: '90',
    mobileCountryCode: '90',
  },
  userType: '',
  isUserExist: false,
};

export const signUpSlice = createSlice({
  name: 'signUp',
  initialState,
  reducers: {
    updateUserInfo: (state, action) => {
      const { value } = action.payload;
      state.userInfo = value;
    },
    updateUserInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.userInfo[field] = value;
    },
    resetUserInfoPreserveField: (state, action) => {
      const { field, value } = action.payload;
      state.userInfo = { ...initialState.userInfo, [field]: value };
    },
    updateUserTypeField: (state, action) => {
      state.userType = action.payload;
    },
    updateIsUserExistField: (state, action) => {
      state.isUserExist = action.payload;
    },
    clearUserInfoFields: (state) => {
      state.userType = initialState.userType;
      state.userInfo = initialState.userInfo;
    },
  },
});

export const userInfoSelector = (state) => state.signUp.userInfo;
export const userTypeSelector = (state) => state.signUp.userType;
export const isUserExistSelector = (state) => state.signUp.isUserExist;
export const isUserCompanySelector = (state) =>
  state.signUp.userType === 'işletme';
export const {
  updateUserInfo,
  updateUserInfoField,
  resetUserInfoPreserveField,
  updateUserTypeField,
  clearUserInfoFields,
  updateIsUserExistField,
} = signUpSlice.actions;

export const signUpReducer = signUpSlice.reducer;
export const signUpReducerName = signUpSlice.name;

export default signUpSlice.reducer;
